// Project Imports
import Augment8DashboardResource from 'core/resources/Augment8DashboardResource';
import PayoutInitializationResource from 'core/resources/PayoutInitialization';
import PayoutResource from 'core/resources/Payout';
import InputFileUploadResource from 'core/resources/InputFileUpload';
import FileManagement from 'core/resources/FileManagement';
import MasterFileUploadResource from 'core/resources/MasterFileUpload';
import Maintainence from 'core/resources/Maintainence';
// import InputFileDownloadResource from 'core/resources/InputFileDownload';
// import MasterFileDownloadResource from 'core/resources/masterFileDownload';
import MyTaskResource from 'core/resources/MyTask';
import UnificationHistoryResource from 'core/resources/UnificationList';
import PayoutHistoryResource from 'core/resources/PayoutHistory';
import AccountingResource from 'core/resources/Accounting';
import SimulationResource from 'core/resources/Simulation';
import RunSimulationResource from 'core/resources/RunSimulation';
import ViewSimulationResource from 'core/resources/ViewSimulation';
// import RuleDetailsResource from 'core/resources/RuleDetails';
import SyncManagementResource from 'core/resources/SyncManagement';
import SyncHistoryResource from 'core/resources/SyncHistoryResource';
import PerformanceDashboardResource from 'core/resources/PerformanceDashboardResource';
import TaskListResource from 'core/resources/TaskListDasboardResource';
import TeamLeadDashboardResource from 'core/resources/TeamLeadDashboardResource';
import TargetSettingResource from 'core/resources/TargetSettingResource';
import HistoricalReportResource from 'core/resources/HistoricalResource';
import UserPerformanceResource from 'core/resources/UserPerformanceResource';
import TargetOverrideResource from 'core/resources/TargetOverride';
import ContractCancellationUpload from 'core/resources/ClawbackFileUpload';
import NeedToPayResource from 'core/resources/NeedToPay';
import UploadUtrResource from 'core/resources/UploadUtr';
import PayoutAdminResource from 'core/resources/PayoutAdminResource';
import PayoutReportResource from 'core/resources/PayoutReportResource';
import NoDuesCertificateResource from 'core/resources/NoDuesCertificateResource';
import HoldUnholdResource from 'core/resources/HoldUnhold';
import HoldResource from 'core/resources/Hold';
import UnholdResource from 'core/resources/Unhold';
import HoldUnholdTaskConfig from 'core/resources/HoldUnholdTaskConfig';
import TaskDetailsConfiguration from 'core/resources/TaskDetailsConfiguration';
import ContestResource from 'core/resources/Contest';
import ContestHistory from 'core/resources/ContestHistory';
import ContestInitialization from 'core/resources/ContestInitialization';
import DataCorrection from 'core/resources/DataCorrection';
import InputFileDataCorrectionResource from 'core/resources/InputFileDataCorrection';
import MasterFileDataCorrectionResource from 'core/resources/masterFileDataCorrection';

import TriggerClawbackResource from 'core/resources/TriggerClawback';
import RecalculationQuery from 'core/resources/RecalculationQueryResource';
// import DashboardMappingResource from 'core/resources/DashboardMapping';
// import ChartMappingResource from 'core/resources/ChartMapping';
// import ChartResource from 'core/resources/Chart';
// import DashboardChartMappingResource from 'core/resources/DashboardChartMapping';

const resources = [
  PerformanceDashboardResource,
  Augment8DashboardResource,
  TaskListResource,
  TeamLeadDashboardResource,
  MyTaskResource,
  InputFileUploadResource,
  FileManagement,
  Augment8DashboardResource,
  MasterFileUploadResource,
  Maintainence,
  PayoutInitializationResource,
  PayoutResource,
  // MasterFileDownloadResource,
  // InputFileDownloadResource,
  UnificationHistoryResource,
  PayoutHistoryResource,
  ContestResource,
  ContestInitialization,
  ContestHistory,
  TargetSettingResource,
  AccountingResource,
  SimulationResource,
  RunSimulationResource,
  ViewSimulationResource,
  SyncManagementResource,
  SyncHistoryResource,
  HistoricalReportResource,
  UserPerformanceResource,

  // DashboardMappingResource,
  // ChartMappingResource,
  // ChartResource,
  // DashboardChartMappingResource,
  // RuleDetailsResource,
  TargetOverrideResource,
  ContractCancellationUpload,
  PayoutAdminResource,
  RecalculationQuery,
  PayoutReportResource,
  NeedToPayResource,
  UploadUtrResource,
  NoDuesCertificateResource,
  HoldUnholdResource,
  HoldUnholdTaskConfig,
  HoldResource,
  UnholdResource,
  TaskDetailsConfiguration,
  DataCorrection,
  InputFileDataCorrectionResource,
  MasterFileDataCorrectionResource,
  TriggerClawbackResource,
];

export default resources;
